export function externalUrl(url) {
  if (!url) {
    return url
  }

  if (url[0] === '/' || url[0] === '#') {
    return url
  }

  if (!/^[\w+.-]+:\/\//m.test(url)) {
    return `https://${url}`
  }

  return url
}
